import { createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-toast"
}
const _hoisted_2 = {
  ref: "backdropRef",
  class: "app-toast__backdrop"
}
const _hoisted_3 = {
  ref: "contentRef",
  class: "app-toast__content"
}
const _hoisted_4 = { class: "app-toast__message" }
const _hoisted_5 = { class: "app-toast__action" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "svg-inline": '',
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18 6L6 18M6 6l12 12",
    stroke: "#201E1E",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createBlock(_Teleport, { to: _ctx.teleportId }, [
    _createVNode(_Transition, {
      css: false,
      appear: "",
      onAppear: _ctx.onAppear,
      onEnter: _ctx.onEnter,
      onLeave: _ctx.onLeave
    }, {
      default: _withCtx(() => [
        (_ctx.isToastOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, null, 512),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ close: _ctx.close })), () => [
                    _createTextVNode(_toDisplayString(_ctx.message), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _renderSlot(_ctx.$slots, "action", _normalizeProps(_guardReactiveProps({ close: _ctx.close }))),
                  _createVNode(_component_base_button, {
                    icon: "",
                    title: "Close",
                    class: "app-toast__close-button",
                    onClick: _ctx.close
                  }, {
                    icon: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ], 512)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["onAppear", "onEnter", "onLeave"])
  ], 8, ["to"]))
}